import React from 'react';
import type { LoyaltyPointsIconProps } from '../..';

export const GoldMulti = ({ size }: Pick<LoyaltyPointsIconProps, 'size'>) => {
    if (size === 'sm') {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="20" viewBox="0 0 38 20" fill="none">
                <path
                    d="M28.3224 18.7C33.1272 18.7 37.0223 14.8049 37.0223 10C37.0223 5.19513 33.1272 1.3 28.3224 1.3C23.5176 1.3 19.6225 5.19513 19.6225 10C19.6225 14.8049 23.5176 18.7 28.3224 18.7Z"
                    fill="#E8D296"
                    stroke="white"
                    strokeWidth="1.4"
                />
                <path
                    d="M18.9353 18.7C23.7402 18.7 27.6352 14.8049 27.6352 10C27.6352 5.19513 23.7402 1.3 18.9353 1.3C14.1305 1.3 10.2354 5.19513 10.2354 10C10.2354 14.8049 14.1305 18.7 18.9353 18.7Z"
                    fill="#CFAD5E"
                    stroke="white"
                    strokeWidth="1.4"
                />
                <path
                    d="M9.61295 18.6353C14.3821 18.6353 18.2482 14.7692 18.2482 10C18.2482 5.23087 14.3821 1.3647 9.61295 1.3647C4.84384 1.3647 0.977734 5.23087 0.977734 10C0.977734 14.7692 4.84384 18.6353 9.61295 18.6353Z"
                    fill="#B18731"
                    stroke="white"
                    strokeWidth="1.4"
                />
            </svg>
        );
    }

    // Size md
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="28" viewBox="0 0 56 28" fill="none">
            <path
                d="M41.8053 26.8C48.8745 26.8 54.6051 21.0692 54.6051 14C54.6051 6.93076 48.8745 1.2 41.8053 1.2C34.7361 1.2 29.0054 6.93076 29.0054 14C29.0054 21.0692 34.7361 26.8 41.8053 26.8Z"
                fill="url(#paint0_linear_1938_153541)"
                stroke="white"
                strokeWidth="1.6"
            />
            <path
                d="M27.8055 26.8C34.8747 26.8 40.6054 21.0692 40.6054 14C40.6054 6.93076 34.8747 1.2 27.8055 1.2C20.7363 1.2 15.0057 6.93076 15.0057 14C15.0057 21.0692 20.7363 26.8 27.8055 26.8Z"
                fill="url(#paint1_linear_1938_153541)"
                stroke="white"
                strokeWidth="1.6"
            />
            <path
                d="M13.9028 26.7029C20.9184 26.7029 26.6057 21.0155 26.6057 13.9999C26.6057 6.98425 20.9184 1.29692 13.9028 1.29692C6.88724 1.29692 1.2 6.98425 1.2 13.9999C1.2 21.0155 6.88724 26.7029 13.9028 26.7029Z"
                fill="url(#paint2_linear_1938_153541)"
                stroke="white"
                strokeWidth="1.6"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1938_153541"
                    x1="41.7082"
                    y1="5.96766"
                    x2="41.8053"
                    y2="26"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E8D296" />
                    <stop offset="1" stopColor="#F9EFD3" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1938_153541"
                    x1="35.1478"
                    y1="26.7978"
                    x2="28.7841"
                    y2="3.75761"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#EDDEB0" />
                    <stop offset="1" stopColor="#C89F4B" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_1938_153541"
                    x1="13.9028"
                    y1="2.09692"
                    x2="13.9028"
                    y2="25.9029"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#AA7E25" />
                    <stop offset="1" stopColor="#DDBF73" />
                </linearGradient>
            </defs>
        </svg>
    );
};
